import React, { useState } from 'react';
import { FiX } from 'react-icons/fi';

const AddGroupModal = ({ isOpen, onClose, boardId, token, onAdd }) => {
  const [formData, setFormData] = useState({
    name: '',
    color: '#4F8DFF'
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/groups`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          boardId: boardId,
          name: formData.name,
          color: formData.color
        })
      });

      if (response.ok) {
        const data = await response.json();
        onAdd(data.group);
        setFormData({ name: '', color: '#4F8DFF' });
        onClose();
      } else {
        const data = await response.json().catch(() => ({}));
        setError(data.detail || 'Failed to create group');
      }
    } catch (err) {
      console.error('Error creating group:', err);
      setError(`Error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const colors = [
    { name: 'Blue', value: '#4F8DFF' },
    { name: 'Purple', value: '#9B6BFF' },
    { name: 'Green', value: '#1DBF73' },
    { name: 'Orange', value: '#F4A340' },
    { name: 'Red', value: '#E24B5B' },
    { name: 'Teal', value: '#66ccff' },
    { name: 'Pink', value: '#ff5ac4' },
    { name: 'Yellow', value: '#ffcb00' },
  ];

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          <h2 className="modal-title">Add New Group</h2>
          <button className="modal-close" onClick={onClose}>
            <FiX size={20} />
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label className="form-label">Group Name *</label>
              <input
                type="text"
                className="input"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
                placeholder="e.g., Design Phase, Construction, etc."
                data-testid="group-name-input"
              />
            </div>
            <div className="form-group">
              <label className="form-label">Group Color</label>
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                {colors.map((color) => (
                  <div
                    key={color.value}
                    onClick={() => setFormData({ ...formData, color: color.value })}
                    style={{
                      width: '40px',
                      height: '40px',
                      borderRadius: '6px',
                      backgroundColor: color.value,
                      cursor: 'pointer',
                      border: formData.color === color.value ? '3px solid #323338' : '2px solid transparent',
                      transition: 'all 0.2s ease'
                    }}
                    title={color.name}
                    data-testid={`group-color-${color.name.toLowerCase()}`}
                  ></div>
                ))}
              </div>
            </div>
            {error && <div className="form-error">{error}</div>}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading} data-testid="submit-group">
              {loading ? 'Creating...' : 'Create Group'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddGroupModal;